import React from 'react';
import Utilities from '@util/Utilities';
import { ArrowTrendingDownIcon, ArrowTrendingUpIcon, ChatBubbleBottomCenterTextIcon, CheckCircleIcon, StarIcon } from '@heroicons/react/20/solid';
import GeneralStatIndicatorPortlet
	from '@app/site/secured/review-manager/fragment/property-overview/component/GeneralStatIndicatorPortlet';
import ReviewsStateStatistics from '@app/model/review/state/ReviewsStateStatistics';

const ReviewsStateStatisticsFragment: React.FunctionComponent<{
	statistics: ReviewsStateStatistics,
	rank: number,
	previousStatistics?: ReviewsStateStatistics,
	variant?: 'default' | 'insightsDigest',
}> = ({ statistics, rank, previousStatistics, variant = 'default' }) => {
	const percentDiff = (current: number, previous?: number) => {
		if (previous === undefined || previous === 0) {
			return undefined;
		}

		return ((current - previous) / previous) * 100;
	};

	const scoreDiff = percentDiff(statistics.score, previousStatistics?.score);

	return <div className="mt-6 mb-8">
		<dl className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
			<GeneralStatIndicatorPortlet
				title="Avg. Rating"
				stat={`${Utilities.formatDouble(statistics.score, 1)}/10`}
				icon={<StarIcon className="h-4 w-4 text-gray-400" />}
				trend={scoreDiff}
				trendSuffix="%"
			/>
			<GeneralStatIndicatorPortlet
				title="Total Reviews"
				stat={`${statistics.numberOfReviews}`}
				icon={<ChatBubbleBottomCenterTextIcon className="h-4 w-4 text-gray-400" />}
				trend={percentDiff(statistics.numberOfReviews, previousStatistics?.numberOfReviews)}
				trendSuffix="%"
			/>
			{variant === 'insightsDigest' && <>
				<GeneralStatIndicatorPortlet
					title="Positive Responses"
					stat={`${statistics.positiveSentimentCount}`}
					icon={<ArrowTrendingUpIcon className="h-4 w-4 text-gray-400" />}
					trend={percentDiff(statistics.positiveSentimentCount, previousStatistics?.positiveSentimentCount)}
					trendSuffix="%"
				/>
				<GeneralStatIndicatorPortlet
					title="Negative Responses"
					stat={`${statistics.negativeSentimentCount}`}
					icon={<ArrowTrendingDownIcon className="h-4 w-4 text-gray-400" />}
					trend={percentDiff(statistics.negativeSentimentCount, previousStatistics?.negativeSentimentCount)}
					trendSuffix="%"
				/>
			</>}
			{variant === 'default' && <>
				<GeneralStatIndicatorPortlet
					title="Response Rate"
					stat={`${Utilities.formatDouble(statistics.responseRate * 100, 1)}%`}
					icon={<CheckCircleIcon className="h-4 w-4 text-gray-400" />}
				/>
				<GeneralStatIndicatorPortlet
					title="Local Rank"
					stat={`#${rank}`}
					icon={<ArrowTrendingUpIcon className="h-4 w-4 text-gray-400" />}
				/>
			</>}
		</dl>
	</div>
}

export default ReviewsStateStatisticsFragment;
